var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout-card",
    {
      staticClass: "card-marketing_campaign",
      attrs: {
        isCustomizable: _vm.settings.isCustomizable,
        placeholder: _vm.placeholder,
        placeholderImg:
          "/ressources/logged/img/dashboard/dashboard-marketing.svg",
        error: _vm.error,
        loading: _vm.loading
      },
      on: {
        "hide-card": function($event) {
          return _vm.$emit("hide-card", "marketing_campaign")
        },
        "refresh-card": function($event) {
          return _vm.fetchCard("marketing_campaign", {}, true)
        }
      }
    },
    [
      _c("template", { slot: "title" }, [
        _vm._v("\n        " + _vm._s(_vm.name) + "\n        "),
        _c("span", { staticClass: "fs-3 regular gray-60 ml-2" }, [
          _vm._v(_vm._s(_vm.$l10n.__("10 dernières campagnes envoyées")))
        ])
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "actions" },
        [
          _vm.settings.canCreate
            ? _c("CompassIconButton", {
                attrs: { icon: "plus", onclick: "Campaign.create()" }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "content" }, [
        (_vm.cardData && _vm.cardData.length > 0) ||
        (_vm.cardData && _vm.cardData.error)
          ? _c(
              "div",
              { staticClass: "hp-10", attrs: { onresize: "resizeCard()" } },
              [
                !_vm.cardData.error
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-table",
                          {
                            ref: "table",
                            staticClass: "table-ellipsis",
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.cardData,
                              "header-cell-class-name": "grey semibold",
                              "row-class-name": "no-hover",
                              height: "100%",
                              stripe: ""
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: { prop: "name", width: "250" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: scope.row.link,
                                              id: "link"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "gray-100 semibold"
                                              },
                                              [_vm._v(_vm._s(scope.row.name))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              { staticClass: "grey mt-1" },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm._f("dateFormatter")(
                                                        scope.row.date,
                                                        "SLASHED_DATE_TIME"
                                                      )
                                                    ) +
                                                    "\n                                "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                588854953
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "recipients",
                                label: _vm.$t.__(
                                  "dashboard.cards.MarketingCampaignCard.recipients"
                                ),
                                "header-align": "right",
                                align: "right"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatStats(
                                                scope.row.recipients
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1704454257
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "open",
                                label: _vm.$t.__(
                                  "dashboard.cards.MarketingCampaignCard.opening"
                                ),
                                "header-align": "right",
                                align: "right"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("numberformat")(
                                                scope.row.open
                                              )
                                            ) + "%"
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2684140025
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "click",
                                label: _vm.$t.__(
                                  "dashboard.cards.MarketingCampaignCard.clics"
                                ),
                                "header-align": "right",
                                align: "right"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatStats(scope.row.click)
                                            )
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2680533207
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "unsub",
                                label: _vm.$t.__(
                                  "dashboard.cards.MarketingCampaignCard.unsubscribed"
                                ),
                                "header-align": "right",
                                align: "right"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("numberformat")(
                                                scope.row.unsub
                                              )
                                            ) + "%"
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                741622066
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }